import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=ec5c3174&scoped=true"
import script from "./Textarea.vue?vue&type=script&lang=ts"
export * from "./Textarea.vue?vue&type=script&lang=ts"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=ec5c3174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5c3174",
  null
  
)

export default component.exports